export default __webpack_public_path__ + "static/Litepaper - French-be321aa7d3a3549467d56d8f6466492f.pdf";